import React from 'react';
import { motion } from 'framer-motion';
export function FooterCTA() {
  return <section className="bg-brand-navy section-padding text-white text-center relative overflow-hidden" data-id="element-163">
      {/* Decorative Background Elements */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-gold/10 rounded-full blur-[100px] pointer-events-none" data-id="element-164"></div>

      <svg className="absolute top-0 left-0 w-full h-full pointer-events-none opacity-20" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-165">
        <path d="M0,100 Q50,0 100,100" fill="none" stroke="currentColor" strokeWidth="0.5" className="text-brand-gold" data-id="element-166" />
        <path d="M0,80 Q50,-20 100,80" fill="none" stroke="currentColor" strokeWidth="0.5" className="text-brand-gold" data-id="element-167" />
      </svg>

      <div className="absolute top-10 right-10 w-4 h-4 rounded-full bg-brand-gold/40 blur-[2px]" data-id="element-168"></div>
      <div className="absolute bottom-20 left-20 w-6 h-6 rounded-full bg-brand-coral/40 blur-[2px]" data-id="element-169"></div>
      <div className="absolute top-1/4 left-1/3 w-2 h-2 rounded-full bg-white/40 blur-[1px]" data-id="element-170"></div>

      <div className="container-custom relative z-10" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} className="max-w-[800px] mx-auto flex flex-col items-center gap-8" data-id="element-172">
          <h2 className="text-[32px] md:text-[48px] text-white font-playfair leading-[1.2]" data-id="element-173">
            Nu trebuie să faci totul singură. <br className="hidden md:block" data-id="element-174" />
            <span className="text-brand-gold italic" data-id="element-175">
              Și nu trebuie să mai aștepți.
            </span>
          </h2>

          <p className="text-[16px] md:text-[18px] text-white/90 max-w-[600px] font-source" data-id="element-176">
            Fiecare lună contează în dezvoltarea copilului tău. Descarcă ghidul
            gratuit și fă astăzi primul pas către claritate și încredere ca
            mamă.
          </p>

          <a href="#mini-curs" className="btn-inverted mt-4 shadow-card-hover" data-id="element-177">
            Descarcă Ghidul Gratuit
          </a>
        </motion.div>
      </div>
    </section>;
}